export default "__VITE_ASSET__C_jAb2QU__"